import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../../../shared/services/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../../../../shared/services/common.service';
import { PageEvent } from '@angular/material/paginator';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { PreviewfileComponent } from '../../../previewfile/previewfile.component';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MSMEParticipantListForInvoice } from '../../../../../shared/models/MSMEParticipantListForInvoice';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-invoicecalculation',
  templateUrl: './invoicecalculation.component.html',
  styleUrl: './invoicecalculation.component.css'
})
export class InvoicecalculationComponent implements OnInit, AfterViewInit, OnDestroy {
  IAId = sessionStorage.getItem('userId');
  eventId: any = sessionStorage.getItem('EventId');
  verified!: number;
  unVerified!: number;
  nonEligible!: number;
  //eligibleCount!: number;
  //nonEligibleCount!: number;
  isSubmitting: boolean = false  
  unVerifiedMSMECount!: number;

  total: number = 0.00;
  length: any;
  pageSize: any 
  displayedData: any[] = [];
  reportData: any[] = [];
  isCalculated: boolean = false;
  loadingSequence: boolean = false;

  allMSMEs: any[] = [];
  eligibleMSMEs: any[] = [];
  nonEligibleMSMEs: any[] = [];

  totalEligibleMSMEs: number = 0;
  totalAttendedMSMEs: number = 0;

  isMSMEVerified: boolean = false;
  isVerifyingMSME: boolean = false;
  invoiceMode: string = 'EDIT';

  // When true we loaded full verified data client-side and should use client pagination
  useClientPaging: boolean = false;

  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();

  dataSource!: MatTableDataSource<MSMEParticipantListForInvoice>
  displayedColumns: string[] = ['rowNum', 'udyamRegistrationNumber', 'eventDate', 'intervention', 'component', 'eventDistrict', 'enterpriseName', 'designation', 'mobileNumber', 'emailId', 'attendedEventsCount', 'status', 'eligibilityReason']
  @ViewChild(MatPaginator) pagination!: MatPaginator;

  @ViewChild(MatPaginator) paginationEvent!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';
  gridLoaded: boolean = false;           // True when MSME grid is loaded
  calculationDone: boolean = false;      // True after calculate button clicked
  documentUploaded: boolean = false;     // True after valid document upload

  allrecord: any[] = [];
  pageSizeOptions: number[] = [10, 20, 50, 100];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;
  DtoPagination =
    {
      "EventId": this.eventId,
      "PageNumber": 1,
      "PageSize": 20,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol": ""
    }

  

  submitType: string | null | undefined;
  uploadError: string | null = null;
  invoiceForm: FormGroup;
  invoiceStatusForm: FormGroup;
  invoiceAccepted = false;

  documentFile: File | null = null;
  documentFileErrors: { typeError: boolean; sizeError: boolean } = { typeError: false, sizeError: false };
  maxSizeInMB = 10;
  loadStatus = false;
  //disableInvoiceUpload: boolean = false;

  msmeList: any[] = [];

  eventIdsToAlwaysEnableUpload: string[] = [
    'SPTECH_CB_3', 'SPTECH_CB_4', 'SPTECH_CB_6', 'WXCPL_CB_8', 'LMC_CB_11', 'LMC_CB_12', 'Justrojgar_CB_15', 'MRSD_CB_20', 'WXCPL_CB_21', 'WXCPL_CB_22', 'SPTECH_CB_23', 'SPTECH_CB_25', 'SPTECH_CB_27', 'SPTECH_CB_28', 'AISECT_CB_29', 'LMC_CB_30', 'SPTECH_CB_32', 'SPTECH_CB_36', 'SPTECH_CB_40', 'WXCPL_CB_41', 'LMC_CB_44', 'SPTECH_CB_47', 'SPTECH_CB_48', 'AISECT_CB_51', 'SPTECH_CB_52', 'WXCPL_CB_54', 'UBC_CB_61', 'SHE_CB_66', 'SHE_CB_67',
  ];

  constructor(private apiService: ApiService, public dialog: MatDialog, private router: Router, private route: ActivatedRoute, private toastr: ToastrService,
    public commonService: CommonService,
    private fb: FormBuilder,
    private datePipe: DatePipe) {
    this.invoiceForm = this.fb.group({
      date: [{ value: new Date(), disabled: true }, Validators.required],
      eventName: ['', Validators.required],
      intervention: ['', Validators.required],
      component: ['', Validators.required],
      ratePerMSME: ['', Validators.required],
      noOfMSMEAttended: ['', Validators.required],

      total: [{ value: '', disabled: true }],
      gstType: ['', Validators.required],
      gstPercent: ['', Validators.required],
      //cgst: ['', [Validators.required, Validators.pattern(this.commonService.gstPercent)]],
      //sgst: ['', [Validators.required, Validators.pattern(this.commonService.gstPercent)]],
      //igst: ['', [Validators.required, Validators.pattern(this.commonService.gstPercent)]],
      totalGST: [{ value: '', disabled: true }],
      //gst: [{ value: '', disabled: true }],
      finalTotal: [{ value: '', disabled: true }],
      uploadInvoice: ['', Validators.required],
      eligibleMSME: [{ value: '', disabled: true }, Validators.required],
      noneligibleMSME: [{ value: '', disabled: true }, Validators.required],
      dateOfCompletion: [''],
      verified: [{ value: '', disabled: true }],
      nonEligible: [{ value: '', disabled: true }]
    });

    // Automatically calculate totals when relevant fields change
    this.invoiceForm.valueChanges.subscribe(() => this.calculateTotals());

    this.invoiceStatusForm = this.fb.group({
      id: [''], invoiceID: [''], eventId: [''], ratePerMSME: [''], noOfMSMEAttended: [''], total: [''], gstType: [''], gstPercent: [''], totalGST: [''], finalTotal: [''], invoiceFileName: [''], invoiceFilePath: [''], invoiceAccepted: [''], paymentDate: [''], paymentMode: [''], utrNumber: [''], amount: [''], status: [''], statusName: [''], eventName: [''], date: [''], eventStatus: [''], intervention: [''], component: [''],
    });
  }

  async ngOnInit(): Promise<void> {
    this.route.queryParams.subscribe(params => {
      this.eventId = params['eventId'] || this.eventId;
      this.invoiceMode = params['mode'] || 'EDIT';
      this.DtoPagination.PageSize = 20;

      if (this.invoiceMode === 'VIEW') {
        this.LoadInvoiceStatusData();
      } else {
        this.CheckIfInvoiceSubmitted();
        this.LoadMSMEList();
      }
    });
  }

  resetCalculation() {
    this.isCalculated = false;
  }

  onCalculateGSTClick(): void {
    if (!this.isMSMEVerified) {
      this.toastr.warning(
        'Please verify MSME eligibility before calculating GST',
        'MSME Verification Required'
      );
      return;
    }

    this.calculateTotalGSTAndFinalAmount();
  }

  calculateTotalGSTAndFinalAmount() {
    this.isCalculated = true;
    const gst = parseFloat(this.invoiceForm.get('gstPercent')?.value || '0');
    const totalGSTPercentage = gst;
    this.total = this.invoiceForm.get('total')?.value
    const totalGSTAmount = (parseFloat(this.total.toString()) * totalGSTPercentage) / 100;
    const newFinalAmount = parseFloat(this.total.toString()) + totalGSTAmount;

    this.invoiceForm.patchValue(
      {
        totalGST: totalGSTAmount.toFixed(2),
        finalTotal: Math.round(newFinalAmount)
      }
    );
    this.calculationDone = true;
  }

  verifyMSMEEligibility() {
    this.totalAttendedMSMEs = Number(this.invoiceForm.get('noOfMSMEAttended')?.value) || 0;
    this.isVerifyingMSME = true;

    this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.VERIFYMSMEELIGIBILITY, {
      IAId: this.IAId,
      EventId: this.eventId
    }).subscribe({
      next: (res) => {
        if (res?.status) {
          // After backend verification, fetch counts and refresh server-paged grid
          this.loadVerifiedMSMEData();
          this.invoiceForm.get('noOfMSMEAttended')?.disable();
        }
      },
      complete: () => this.isVerifyingMSME = false
    });
  }

  private loadVerifiedMSMEData() {
    // Use a large page size to compute overall counts from verified endpoint
    const countsDto = { ...this.DtoPagination, PageNumber: 1, PageSize: 999999 };

    this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETMSMELISTFORIAA, countsDto)
      .subscribe(resp => {
        if (!resp?.status || !Array.isArray(resp.data)) return;

        const eligibleCount = resp.data.filter((x: any) => x.status === 'Eligible').length;
        const nonEligibleCount = resp.data.filter((x: any) => x.status === 'Non-Eligible').length;

        const unVerifiedCount = Math.max(this.totalAttendedMSMEs - (eligibleCount + nonEligibleCount), 0);

        this.verified = eligibleCount;
        this.nonEligible = nonEligibleCount;
        this.unVerified = unVerifiedCount;

        this.invoiceForm.get('eligibleMSME')?.setValue(this.verified);
        this.invoiceForm.get('noneligibleMSME')?.setValue(this.nonEligible);

        // mark verified mode and refresh server-paged data (start from first page)
        this.isMSMEVerified = true;
        this.DtoPagination.PageNumber = 1;
        this.DtoPagination.PageSize = this.pagination ? this.pagination.pageSize : this.pageSize;
        this.refreshPagedData();
      });
  }

  // ... inside loadData() subscription replace the early return guard with nothing so server responses are always applied ...
  loadEventDetailsByIAAndEventID() {
    var dtDtoEventDetailsByIAIDParameters = {
      EventId: this.eventId,
      IAId: this.IAId
    }
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETEVENTDETAILSBYIAID, dtDtoEventDetailsByIAIDParameters).subscribe(
      (result) => {
        if (result.status) {
          this.invoiceForm.patchValue({
            eventName: result.data.eventName,
            intervention: result.data.intervention,
            component: result.data.component,
            noOfMSMEAttended: result.data.noOfMSMEAttended,
            ratePerMSME: Number(result.data.ratePerMSME).toFixed(2),
            dateOfCompletion: result.data.dateOfCompletion,
            gstType: result.data.gstType,
            gstPercent: result.data.gstPercent,
          });
          this.invoiceForm.get('eventName')?.disable();
          this.invoiceForm.get('intervention')?.disable();
          this.invoiceForm.get('component')?.disable();
          this.invoiceForm.get('noOfMSMEAttended')?.disable();
          this.invoiceForm.get('ratePerMSME')?.disable();
          this.invoiceForm.get('dateOfCompletion')?.disable();
          this.invoiceForm.get('gstType')?.disable();
          this.invoiceForm.get('gstPercent')?.disable();

          const invCreatedDate = new Date(result.data.dateOfCompletion);
          const formattedCreatedDate = `${invCreatedDate.getFullYear()}-${(invCreatedDate.getMonth() + 1).toString().padStart(2, '0')}-${invCreatedDate.getDate().toString().padStart(2, '0')}`;
          this.invoiceForm.get('dateOfCompletion')?.setValue(formattedCreatedDate);
        }
      }
    );
  }

  loadInvoiceForView() {
    const dtoICEventId = { EventId: this.eventId };
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETVIEWINVOICECALCULATIONDATA, dtoICEventId)
      .subscribe(result => {
        if (result?.status) {
          this.loadStatus = true;
          this.invoiceStatusForm.patchValue(result.data);
          this.invoiceStatusForm.disable();
          this.verified = result.data.verified;
          this.nonEligible = result.data.nonEligible;
          this.unVerified = result.data.unVerified;
        }
      });
  }

  CheckIfInvoiceSubmitted() {
    var dtoEventId = {
      IAId: this.IAId,
      EventId: this.eventId,
      Resubmit: sessionStorage.getItem('Resubmit')
    }
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.CHECKIFINVOICESUBMITTEDFOREVENTID, dtoEventId).subscribe(
      (result) => {
        if (result.status && result.message === 'Invoice for this event is already submitted') {
          this.LoadInvoiceStatusData();
        }
        else if (result.status && result.message === 'Resubmit is submitted') {
          this.LoadInvoiceStatusData();
        }
        else {
          this.loadEventDetailsByIAAndEventID();
        }
      }
    );
  }

  LoadInvoiceStatusData() {
    var dtoEventId = {
      IAId: this.IAId,
      EventId: this.eventId,
      Resubmit: sessionStorage.getItem("RejectedStatus"),
    }
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETINVOICESTATUSDATA, dtoEventId).subscribe(
      (result) => {
        if (result.status) {
          this.loadStatus = true;
          this.invoiceStatusForm.disable();
          this.invoiceStatusForm.patchValue(result.data);
          this.invoiceStatusForm.controls['invoiceAccepted'].setValue(result.data?.invoiceAccepted ? 'Yes' : '--');
          this.verified = result.data.verified;
          this.nonEligible = result.data.nonEligible;
          this.unVerifiedMSMECount = result.data.unVerifiedMSMECount;
          const date = new Date(result.data.date);
          const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
          this.invoiceStatusForm.get('date')?.setValue(formattedDate);

          if (result.data.paymentDate) {
            const invCreatedDate = new Date(result.data.paymentDate);
            const formattedCreatedDate = `${invCreatedDate.getFullYear()}-${(invCreatedDate.getMonth() + 1).toString().padStart(2, '0')}-${invCreatedDate.getDate().toString().padStart(2, '0')}`;
            this.invoiceStatusForm.get('paymentDate')?.setValue(formattedCreatedDate);
          }
        }
      }
    );
  }

  calculateTotals() {
    const ratePerMSME = parseFloat(this.invoiceForm.get('ratePerMSME')?.value) || 0;
    const eligibleMSME = Number(this.invoiceForm.get('eligibleMSME')?.value) || 0;
    const total = ratePerMSME * eligibleMSME;

    this.invoiceForm.patchValue(
      { total: total.toFixed(2) },
      { emitEvent: false }
    );
  }

  onCancel() {
    this.router.navigate(['/invoicedashboardia']);
  }

  onFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length) {
      this.documentFile = input.files[0];
      this.documentFileErrors = { typeError: false, sizeError: false };
      this.uploadError = null;
      this.invoiceForm.get('uploadInvoice')?.setErrors(null);
      const validTypes = ['application/pdf'];
      if (!validTypes.includes(this.documentFile.type)) {
        this.documentFileErrors.typeError = true;
        this.uploadError = 'Please upload pdf type of file.';
        this.invoiceForm.get('uploadInvoice')?.setErrors({ typeError: true });
      } else {
        this.invoiceForm.get('uploadInvoice')?.setErrors(null);
      }
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024;
      if (this.documentFile.size > maxSizeInBytes) {
        this.documentFileErrors.sizeError = true;
        this.uploadError = 'Please upload invoice of 10 MB max.';
        this.invoiceForm.get('uploadInvoice')?.setErrors({ sizeError: true });
      }
      if (!this.documentFileErrors.typeError && !this.documentFileErrors.sizeError) {
        this.invoiceForm.get('uploadInvoice')?.setErrors(null);
        this.documentUploaded = true;
      }
    } else {
      this.documentUploaded = false;
      this.invoiceForm.get('uploadInvoice')?.setErrors({ required: true });
    }
  }

  onSubmit() {
    if (!this.invoiceForm.valid || this.isSubmitting) {
      this.invoiceForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;

    this.invoiceForm.get('eligibleMSME')?.enable();
    this.invoiceForm.get('noneligibleMSME')?.enable();
    this.invoiceForm.get('total')?.enable();
    this.invoiceForm.get('totalGST')?.enable();
    this.invoiceForm.get('finalTotal')?.enable();

    if (this.invoiceForm.get('date')?.value) {
      const value = this.datePipe.transform(
        this.invoiceForm.get('date')?.value,
        'yyyy-MM-dd'
      );
      this.invoiceForm.get('date')?.setValue(value);
    }

    const formData = new FormData();

    formData.append('date', this.invoiceForm.get('date')?.value);
    formData.append('eventId', this.eventId);
    formData.append('ratePerMSME', this.invoiceForm.get('ratePerMSME')?.value);
    formData.append('noOfMSMEAttended', this.invoiceForm.get('noOfMSMEAttended')?.value);
    formData.append('total', this.invoiceForm.get('total')?.value);
    formData.append('gstType', this.invoiceForm.get('gstType')?.value);
    formData.append('gstPercent', this.invoiceForm.get('gstPercent')?.value);
    formData.append('totalGST', this.invoiceForm.get('totalGST')?.value);
    formData.append('finalTotal', this.invoiceForm.get('finalTotal')?.value);
    formData.append('verified', this.verified?.toString() || '0');
    formData.append('nonEligible', this.nonEligible?.toString() || '0');
    formData.append('iaId', this.IAId || '');

    if (this.documentFile) {
      formData.append('invoiceFile', this.documentFile, this.documentFile.name);
    }

    this.apiService.postRequest(API_ENDPOINTS.MASTERS.INVOICE.INSERTINVOIDEDETAILSBYIA, formData)
      .subscribe({
        next: (result) => {
          if (result.status) {
            this.toastr.success(
              this.submitType == '1'
                ? 'Invoice Resubmitted Successfully'
                : 'Invoice Submitted Successfully'
            );
            this.invoiceForm.disable();
          } else {
            this.toastr.error(result.message);
            this.isSubmitting = false;
          }
        },
        error: () => {
          this.isSubmitting = false;
        }
      });
  }

  onDownloadInvoice() {
    var filePath = this.invoiceStatusForm.get('invoiceFilePath')?.value;
    var fileName = this.invoiceStatusForm.get('invoiceFileName')?.value;
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    });
  }

  blockManualInput(event: KeyboardEvent): void {
    event.preventDefault();
  }

  openFilePreviewDialog(): void {
    var filePath = this.invoiceStatusForm.get('invoiceFilePath')?.value;
    var fileName = this.invoiceStatusForm.get('invoiceFileName')?.value;
    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(PreviewfileComponent, {
          width: '80%',
          height: '80',
          data: { fileUrl, fileName }
        });
      }
    });
  }

  ngAfterViewInit() {
    // Wait for paginator to be fully initialized
    if (!this.pagination) {
      setTimeout(() => this.loadData(), 100);
    } else {
      // Ensure paginator is initialized with proper defaults
      if (this.pagination) {
        this.pagination.pageSizeOptions = this.pageSizeOptions;
        this.pagination.pageSize = this.pageSize;
      }
      this.loadData();
    }
  }

  loadData() {

    this.submitType = sessionStorage.getItem("RejectedStatus");

    if (!this.pagination) {
      return;
    }

    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadDataSubscription.unsubscribe();

    // Initialize pagination state on first load
    if (this.pageIndex === undefined || this.pageIndex === null) {
      this.pageIndex = 0;
      this.DtoPagination.PageNumber = 1;
    }

    // Create separate streams so only search/sort reset to first page but page change does not
    const sort$ = this.sort.sortChange.pipe(map(() => ({ resetPage: true })));
    const search$ = this.term$.pipe(debounceTime(1100), distinctUntilChanged(), map(() => ({ resetPage: true })));
    const page$ = this.pagination.page.pipe(map(() => ({ resetPage: false })));

    // Emit initial load event to fetch first page data
    const initialLoad$ = of({ resetPage: false });

    this.loadDataSubscription = merge(initialLoad$, sort$, search$, page$)
      .pipe(
        takeUntil(this.destroy$),
        switchMap(({ resetPage }) => {
          if (resetPage) {
            this.pagination.pageIndex = 0;
          }

          // sync DTO with paginator
          this.DtoPagination.PageNumber = (this.pagination.pageIndex || 0) + 1;
          this.DtoPagination.PageSize = this.pagination.pageSize || this.pageSize;
          this.DtoPagination.SortColumn = this.sort?.active || '';
          this.DtoPagination.SortDirection = this.sort?.direction || '';
          this.DtoPagination.SearchCol = this.commonService.searchText || '';

          const endpoint = this.isMSMEVerified
            ? API_ENDPOINTS.MASTERS.INVOICE.GETMSMELISTFORIAA
            : API_ENDPOINTS.MASTERS.INVOICE.GETMSMELISTFORIA;

          return this.apiService.getRequest(endpoint, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            // set length from API response (totalRecords) - ensure it's a number
            this.length = resp['totalRecords'] ?? resp['total_count'] ?? 0;
            //console.log('Total records from API:', this.length);
          }
          return resp?.data || [];
        })
      )
      .subscribe(data => {



        //console.log(data);
        this.dataSource = new MatTableDataSource<MSMEParticipantListForInvoice>(data);
        //this.dataSource.paginator = this.pagination;
        //this.dataSource.sort = this.sort;

        this.dataSource = new MatTableDataSource(data);
        this.dataSource.sort = this.sort;

        // keep page-related state consistent
        this.pageSize = this.DtoPagination.PageSize;
        this.pageIndex = (this.DtoPagination.PageNumber || 1) - 1;

        this.adjustPaginator();
        
        // Explicitly update the paginator length - this is critical for showing correct total
        if (this.pagination) {
          this.pagination.length = this.length;
        }

        this.gridLoaded = true;
      });
  }

  refreshPagedData() {
    if (!this.pagination) return;

    try {
      this.DtoPagination.PageNumber = this.DtoPagination.PageNumber || (this.pagination.pageIndex + 1);
      this.DtoPagination.PageSize = this.DtoPagination.PageSize || this.pagination.pageSize || this.pageSize;
      this.DtoPagination.SortColumn = this.sort?.active || '';
      this.DtoPagination.SortDirection = this.sort?.direction || '';
      this.DtoPagination.SearchCol = this.commonService.searchText || '';

      const endpoint = this.isMSMEVerified
        ? API_ENDPOINTS.MASTERS.INVOICE.GETMSMELISTFORIAA
        : API_ENDPOINTS.MASTERS.INVOICE.GETMSMELISTFORIA;

      this.apiService.getRequest(endpoint, this.DtoPagination)
        .subscribe({
          next: (resp) => {
            if (resp && resp.status) {
              // Ensure length is properly set from API response
              this.length = resp['totalRecords'] ?? resp['total_count'] ?? 0;
              //console.log('Total records updated:', this.length);
              const data = resp.data || [];
              this.dataSource = new MatTableDataSource<MSMEParticipantListForInvoice>(data);
              //this.dataSource.paginator = this.pagination;
              this.dataSource.sort = this.sort;

              // sync UI paginator
              this.pageSize = this.DtoPagination.PageSize;
              this.pageIndex = (this.DtoPagination.PageNumber || 1) - 1;
              this.adjustPaginator();

              // Explicitly update paginator length
              if (this.pagination) {
                this.pagination.length = this.length;
              }

              this.gridLoaded = true;
            }
          },
          error: (err) => {
            console.error('Error loading paged data:', err);
          }
        });
    } catch (error) {
      console.error('Error in refreshPagedData:', error);
    }
  }

  adjustPaginator() {
    const totalPages = Math.max(1, Math.ceil((this.length || 0) / (this.pageSize || 1)));
 if (this.pageIndex >= totalPages) {
      this.pageIndex = Math.max(0, totalPages - 1);
  this.DtoPagination.PageNumber = this.pageIndex + 1;
    }
    if (this.pagination) {
      this.pagination.pageIndex = this.pageIndex;
      this.pagination.length = this.length;
      this.pagination.pageSize = this.pageSize;
    }
  }

  onPageChange(e: PageEvent) {
    if (!e) return;
    this.pageEvent = e;
    // DO NOT set: this.length = e.length (it's only the page size!)
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
  this.DtoPagination.PageSize = e.pageSize;

    //console.log('Page changed - PageIndex:', this.pageIndex, 'PageSize:', this.pageSize, 'Total Length:', this.length);

    // If we loaded full verified data on client side, let MatTable handle paging — do not call server
    if (this.useClientPaging) {
  // MatTableDataSource + MatPaginator already update displayed rows automatically
      return;
    }

    // Ensure pagination is ready before refreshing
    if (this.pagination) {
      this.refreshPagedData();
    }
  }

  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  convertDateToYYYYMMDD(date: Date): string {
    const adjustedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const year = adjustedDate.getFullYear();
    const month = String(adjustedDate.getMonth() + 1).padStart(2, '0');
    const day = String(adjustedDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  exportToExcel(): void {
    const fileName = 'MSME_Participant_List.xlsx';

    const DtoPagination = {
      EventId: this.eventId,
      PageNumber: 1,
      PageSize: 9999999,
      SortColumn: "",
      SortDirection: "",
      SearchTerm: "",
      SearchCol: this.commonService.searchText,
    };

    this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETMSMELISTFORIA, DtoPagination).subscribe(
      result => {
        if (result.status) {
          this.allrecord = result.data;

          if (!this.allrecord || this.allrecord.length === 0) {
            this.toastr.error('No data available to export.');
            return;
          }

          const excelData = this.allrecord.map((item, index) => ({
            'SR. NO': item.rownum,
            'UDYAM REGISTRATION NUMBER': item.udyamRegistrationNumber,
            'EVENT DATE': item.eventDate,
            'INTERVENTION': item.intervention,
            'COMPONENT': item.component,
            'eventDISTRICT': item.eventDistrict,
            'ENTERPRISE NAME': item.enterpriseName,
            'DESIGNATION': item.designation,
            'MOBILE NUMBER': item.mobileNumber,
            'EMAIL ID': item.emailId,
            'ATTENDED EVENTS COUNT': item.attendedEventsCount,
            'STATUS': item.status,
            'ELIGIBILITYREASON': item.eligibilityReason,
          }));

          const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

          const columnWidths = [
            { wch: 8 }, { wch: 30 }, { wch: 20 }, { wch: 30 }, { wch: 30 }, { wch: 30 },
            { wch: 30 }, { wch: 30 }, { wch: 20 }, { wch: 30 }, { wch: 10 }, { wch: 30 }, { wch: 30 },
          ];
          worksheet['!cols'] = columnWidths;

          const workbook: XLSX.WorkBook = {
            Sheets: { 'Participant List': worksheet },
            SheetNames: ['Participant List'],
          };

          const excelBuffer: any = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
          });

          const data: Blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
          });

          saveAs(data, fileName);
          this.toastr.success('Excel exported successfully!');
        }
      }
    );
  }

  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }

  async LoadMSMEList(): Promise<void> {
    this.loadingSequence = true;
    const dtoEventId = { EventId: this.eventId };
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETMSMELISTFORIA, dtoEventId).subscribe({
    next: (result) => {
        if (result?.status) {
          this.msmeList = result.data || [];
        }
 },
      error: (err) => {
        console.error('Error loading MSME list:', err);
        this.msmeList = [];
      },
   complete: () => {
    this.loadingSequence = false;
      }
    });
  }
}
